import { render } from "./SwitchTabs.vue?vue&type=template&id=56fe0998&scoped=true"
import script from "./SwitchTabs.vue?vue&type=script&lang=js"
export * from "./SwitchTabs.vue?vue&type=script&lang=js"

import "./SwitchTabs.vue?vue&type=style&index=0&id=56fe0998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe0998"]])

export default __exports__